import PropTypes from 'prop-types';
import Image from '../../images/Image';
//

// ----------------------------------------------------------------------

SingleFilePreview.propTypes = {
  file: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default function SingleFilePreview({ file, originalSrc }) {
  if (!file && !originalSrc) {
    return null;
  }

  let imgUrl
  if(file){
    imgUrl = typeof file === 'string' ? file : file.preview;
  }else if(originalSrc){
    imgUrl = originalSrc
  }

  console.log('Single preview',imgUrl)

  return (
    <Image
      alt="file preview"
      src={imgUrl}
      sx={{
        top: 8,
        left: 8,
        zIndex: 8,
        borderRadius: 1,
        position: 'absolute',
        width: 'calc(100% - 16px)',
        height: 'calc(100% - 16px)',
      }}
    />
  );
}
